/**
 * Created by mac on 7/26/18
 */

const TropicalExpeditionFeastWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, options) {
        this.mission = mission;

        options = options || {};
        this.options = options;

        const offer = this.offer = cleverapps.offerManager.findOffer({ mission: mission.type });

        this._super({
            name: "TropicalExpeditionFeastWindow",
            content: new TropicalExpeditionFeastView(this),
            noBackground: true,
            closeButton: false,
            styles: cleverapps.styles.TropicalExpeditionFeastWindow.window,
            notCloseByTouchInShadow: true,
            offerWindowButton: offer ? {
                text: Messages.get(`FeastMissionWindow.${mission.getName()}.offer`),
                offerType: offer.type,
                onClicked: this.onOfferClicked.bind(this),
                bundle: bundleName,
                badgeText: Messages.get(`FeastMissionWindow.${mission.getName()}.offerBadge`)
            } : undefined,
            openSound: options.openSound
        });

        this.mission.updateCompetitionResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    onShow: function () {
        this._super();

        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();

        this._super();
    },

    listBundles: function () {
        return ["expeditionfeast_window", cleverapps.skins.getSlot("expeditionFeastBundle").getBundleName()];
    }
});

cleverapps.styles.TropicalExpeditionFeastWindow = {
    verticalWindow: {
        windowShowUpAnimation: undefined,
        Background: {
            padding: {
                x: -10
            }
        }
    },

    window: {
        windowShowUpAnimation: undefined
    }
};